import { all, fork } from "redux-saga/effects";
import axios from "axios";
import adminUserSaga from "./adminUser";
import adminIndividualSaga from "./adminIndividual";
import adminBusinessSaga from "./adminBusiness";
import { API_URL } from "../constants";
import { getAdminToken, clearAdminToken } from "../util/auth";

axios.defaults.baseURL = API_URL;
axios.defaults.withCredentials = true;

// 로그인 토큰을 저장소에서 읽어와 모든 요청에 자동으로 실어 보냅니다.
// (로그인/토큰 방식으로 바꾼 이유는 util/auth.js 상단 설명 참고)
axios.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 토큰이 만료되었거나 유효하지 않으면(401) 저장된 토큰을 지웁니다.
// 화면 전환 시 App.js의 로그인 확인 로직이 이걸 보고 로그인 화면으로 보냅니다.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      clearAdminToken();
    }
    return Promise.reject(error);
  }
);

export default function* rootSaga() {
  yield all([
    fork(adminUserSaga),
    fork(adminIndividualSaga),
    fork(adminBusinessSaga),
  ]);
}
